export const VIPTagValue = 219
export const GUEST_COMMENT_LIMIT = 500
export const GUEST_COMMENT_CONTEXT_MENU_LIMIT = 147
